import React, {useEffect} from "react";
import {useSearchParams} from "react-router-dom";


const KakaoLoginTest = () => {
    const [query] = useSearchParams()
    const status = query.get("status")
    const jsKey = query.get("jsKey")
    const resKey = query.get("resKey")

    if (status) {
        alert(status === 'true' ? "정상 동작하였습니다." : "로그인에 실패했습니다. 키를 다시 확인하세요.")
    }

    useEffect(() => {
        if (status) return

        if (window.Kakao && window.Kakao.isInitialized()) {
            return;
        }

        // 스크립트 태그 생성
        const script = document.createElement('script');
        script.src = 'https://t1.kakaocdn.net/kakao_js_sdk/2.7.2/kakao.min.js';
        script.integrity = 'sha384-TiCUE00h649CAMonG018J2ujOgDKW/kVWlChEuu4jK2vxfAAD0eZxzCKakxg55G4';
        script.crossOrigin = 'anonymous';
        script.async = true;

        // 로드 완료 후 실행될 콜백
        script.onload = () => {
            if (window.Kakao && !window.Kakao.isInitialized()) {
                window.Kakao.init(jsKey); // 키 초기화
            }
        };

        script.onerror = () => {
            console.error('Kakao SDK Load Failed');
        };

        document.head.appendChild(script);
    }, []);


    const handleKakaoLogin = () => {
        if (!window.Kakao) {
            alert('카카오 로그인을 준비 중입니다.');
            return;
        }

        window.Kakao.Auth.authorize({
            redirectUri: "https://api.omoplay.com/kakao/auth/token",
            state: `${resKey},test,https://admin.omoplay.com/sysadmin/wizard/login-test`
        });
    };

    return (
        <>
            {
                status ? (<div>창을 닫아주세요.</div>) : (
                    <button
                        onClick={handleKakaoLogin}
                        className="w-full mt-auto bg-yellow-400 text-white rounded-xl py-4 font-semibold text-[16px] hover:bg-yellow-500 transition-colors mb-4"
                    >
                        카카오 싱크 적용 테스트
                    </button>
                )
            }
        </>
    )
}

export default KakaoLoginTest